import { Button, ButtonProps, Modal, ModalProps } from "antd";
import { defineDriver } from "localforage";
import { cloneElement, forwardRef, ReactNode, useImperativeHandle, useRef, useState } from "react";

export interface IModalBaseProps extends ModalProps {
    buttonOpen?:ReactNode;
    textButtonOpen?:ReactNode;
    propsButtonOpen?:ButtonProps;
    onOpen?:() => void;
    onClose?:() => void;
    /** @default false */
    initOpen?:boolean;
    stateOpen?:[boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

export type ModalBaseRefType = {
    abrir:() => void;
    fechar:() => void;
};
const ModalBase = forwardRef<ModalBaseRefType, IModalBaseProps>(function ModalBase({
    children,
    initOpen,
    onOpen,
    onClose,
    buttonOpen,
    textButtonOpen,
    destroyOnClose,
    propsButtonOpen,
    cancelButtonProps,
    okButtonProps,
    stateOpen,
    ...props
}, ref) {
    //#region Default Values
    initOpen = initOpen ?? false;

    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.size = propsButtonOpen.size ?? "small";
    propsButtonOpen.type = propsButtonOpen.type ?? "primary";

    cancelButtonProps = cancelButtonProps ?? {};
    cancelButtonProps.size = cancelButtonProps.size ?? "middle";
    cancelButtonProps.type = cancelButtonProps.type ?? "primary";
    cancelButtonProps.danger = cancelButtonProps.danger ?? true;

    okButtonProps = okButtonProps ?? {};
    okButtonProps.size = okButtonProps.size ?? "middle";
    okButtonProps.type = okButtonProps.type ?? "primary";
    okButtonProps.danger = okButtonProps.danger ?? false;
    
    const stateOpenInterna = useState(initOpen);
    const [ aberta, setAberta ] = stateOpen ?? stateOpenInterna;
    //#endregion

    function abrirModal() {
        onOpen?.();
        setAberta(true);
    }
    
    function fecharModal() {
        onClose?.();
        setAberta(false);
    }

    useImperativeHandle(ref, () => {
        return {
            abrir() {
                abrirModal();
            },
            fechar() {
                fecharModal();
            },
        };
    }, []);
    

    return <>
        {
            buttonOpen 
            && cloneElement(buttonOpen as React.ReactElement<any>, { onClick : abrirModal }) 
            || <Button {...propsButtonOpen} onClick={abrirModal}>{textButtonOpen}</Button>
        }
        <Modal
            {...props}
            open={aberta}
            onCancel={fecharModal}
            destroyOnClose={destroyOnClose ?? true}
            cancelButtonProps={cancelButtonProps}
            okButtonProps={okButtonProps}
        >
            {children}
        </Modal>
    </>;
});

export default ModalBase;